import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  root: {
    zIndex: 10,
    position: 'absolute',
    top: '0',
    left: '0',
    bottom: '0',
    right: '0',
    display: 'grid',
    placeItems: 'center',
    background: 'rgba(255, 255, 255, 0.9)',
    '& > *': {
      pointerEvents: 'none'
    }
  },

  content: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    border: `2px dashed ${theme.palette.primary.main}`,
    borderRadius: '16px',
    boxSizing: 'border-box',
    width: '364px',
    height: '364px',
    padding: '40px',
    background: '#FCECFF'
  },

  icon: {
    marginTop: '68px',
    marginBottom: '24px'
  },

  text: {
    marginBottom: '8px',
    color: 'black'
  },

  title: {
    fontSize: theme.size.base
  },

  subtitle: {
    fontSize: theme.size.base
  }
}))

export default useStyles
